<template lang="html">
  <v-dialog
    persistent
    v-model="dialog"
    transition="dialog-transition"
    max-width="600px"
  >
    <v-btn
      color="primary"
      fab
      slot="activator"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      absolute
      round
    >
      <v-icon>edit</v-icon>
    </v-btn>
    <v-card>
      <v-container pa-0>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title primary-title>
              <h1 class="headline">Edit Profile Info</h1>
            </v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text>
              <v-text-field
                name="displayName"
                label="User Name"
                v-model="editedUserName"
              ></v-text-field>
              <v-text-field
                name="editedPhotoURL"
                label="Cover Photo (URL)"
                v-model="editedPhotoURL"
              ></v-text-field>
            </v-card-text>
            <v-card-media
              height="200px"
              contain
              class="mb-4"
              :src="photoPreview"
            >
            </v-card-media>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
              <v-btn flat color="primary" @click="onSave">Save</v-btn>
              <v-btn flat color="error" @click="onCancel">Cancel</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      dialog: false,
      editedUserName: this.autofillData.displayName,
      editedPhotoURL: this.autofillData.photoURL
    }
  },
  computed: {
    ...mapState({
      user: 'user'
    }),
    photoPreview () {
      return this.editedPhotoURL || ''
    }
  },
  methods: {
    onCancel () {
      this.dialog = false
      // re-autofill data
      this.editedUserName = this.autofillData.displayName
      this.editedPhotoURL = this.autofillData.photoURL
    },
    onSave () {
      this.dialog = false
      const saveState = {
        id: this.$store.state.user.id
      }
      if (this.editedPhotoURL) {
        saveState.photoURL = this.editedPhotoURL
        this.$store.commit('user/setPhotoURL', this.editedPhotoURL)
      }
      if (this.editedUserName) {
        saveState.displayName = this.editedUserName
        this.$store.commit('user/setDisplayName', this.editedUserName)
      }
      this.$store.dispatch('user/saveState', saveState)
    }
  },
  props: [
    'top',
    'bottom',
    'right',
    'left',
    'autofillData'
  ]
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Profile/ProfileEditDialog.vue